import { useContext } from "react";
import { ContextEngine } from "./ContextEngine";
import { initEngine } from "./events/bus";
import { initEngineEvents } from "./initEngineEvents";

export default function EngineBootstrap() {
  const { getContext, updateContext } = useContext(ContextEngine);

  initEngine({
    _getContext: getContext,
    _updateContext: updateContext,
  });

  initEngineEvents();

  return null;
}
